import { Box, Button } from "@mui/material";

export default function Registry() {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <Button
        variant="outlined"
        href="https://www.myregistry.com/wedding-registry/tori-mclean-and-adam-baker-headingley-mb/5068181"
        target="_blank"
        sx={{
          textAlign: "center",
          margin: "1rem",
          marginTop: "3rem",
          fontSize: "2rem",
          padding: "0 2rem",
          backgroundColor: "rgb(80, 97, 117)",
          color: "rgb(255, 255, 237)",
          "&:hover": {
            backgroundColor: "rgb(64, 80, 97)", // slightly darker for hover
          },
        }}
      >
        Take me to the registry!
      </Button>
    </Box>
  );
}
